var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.9 57",
    xmlSpace: "preserve",
    width: 115.9,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2870ED;}\n\t.st1{fill:#FEFEFE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(-10.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 122.1,57 H 15.2 c -2.5,0 -4.5,-2 -4.5,-4.5 V 4.5 C 10.7,2 12.7,0 15.2,0 h 106.9 c 2.5,0 4.5,2 4.5,4.5 v 48 c 0,2.5 -2,4.5 -4.5,4.5",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 86.6,28.4 H 97.9 V 26.9 H 86.6 c 0,-0.2 0,-3.6 0,-5.2 0,-1.3 0.9,-2.7 2.6,-2.6 3.2,0.1 6.3,0.1 9.5,0 1.4,0 2.6,1 2.6,2.6 0,0.2 0,0.5 0,0.8 H 90 V 24 h 11.3 c 0,0.2 0,3.6 0,5.2 0,1.6 -1,2.6 -2.6,2.6 -3.1,0 -6.3,0 -9.4,0 -1.6,0 -2.7,-1 -2.7,-2.6 0,-0.3 0,-0.6 0,-0.8",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 93.9,17.5 c -1.3,0 -2.4,-1.1 -2.4,-2.4 0,-1.3 1.1,-2.4 2.4,-2.4 1.3,0 2.4,1.1 2.4,2.4 0.1,1.3 -1,2.4 -2.4,2.4",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 36,20.2 c 0,-0.7 0.3,-1.1 1,-1.1 h 7.2 v 1.4 c 0,0.7 -0.4,1 -1.1,1 h -4.2 v 2.6 h 4.6 v 2.3 h -4.6 v 2.9 h 5.5 v 1.4 c 0,0.7 -0.4,1 -1.1,1 H 37 c -0.7,0 -1,-0.4 -1,-1.1 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 48.3,21.5 v 0 3.3 h 2.1 c 1.2,0 2,-0.4 2,-1.7 0,-1.2 -0.8,-1.6 -2,-1.6 z m -2.8,-1.3 c 0,-0.7 0.3,-1.1 1,-1.1 h 4.2 c 3,0 4.6,1.6 4.6,4.1 0,1.8 -0.9,3 -2.5,3.6 l 2.9,4.4 c 0.1,0.2 0.2,0.4 0.2,0.5 h -2.6 c -0.5,0 -0.7,0 -1.1,-0.6 l -2.4,-3.9 h -1.5 v 4.5 H 45.4 V 20.2 Z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 60.4,19 c 2.5,0 4,0.3 4,1.4 v 1.1 h -3.7 c -1.1,0 -1.5,0.3 -1.5,1 0,1.7 5.9,1.4 5.9,5.6 0,2 -1.2,3.7 -4.9,3.7 -2.3,0 -4.1,-0.3 -4.1,-1.4 v -1.1 h 4.3 c 1.1,0 1.7,-0.4 1.7,-1.1 0,-1.9 -5.9,-1.6 -5.9,-5.9 0,-1.8 1.3,-3.3 4.2,-3.3",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 73.8,19.1 v 1.4 c 0,0.7 -0.4,1 -1.1,1 H 70.9 V 31.7 H 68 V 21.5 h -2.9 v -1.4 c 0,-0.7 0.4,-1 1.1,-1 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 74.7,20.2 c 0,-0.7 0.3,-1.1 1,-1.1 h 7.2 v 1.4 c 0,0.7 -0.4,1 -1.1,1 h -4.2 v 2.6 h 4.6 v 2.3 h -4.6 v 2.9 H 83 v 1.4 c 0,0.7 -0.4,1 -1.1,1 h -6.2 c -0.7,0 -1,-0.4 -1,-1.1 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 38.8,40.9 v 0 c 0.8,0 1.4,-0.2 1.4,-1.1 0,-0.8 -0.6,-1.1 -1.4,-1.1 h -1.6 v 2.2 z m -0.2,-3.3 v 0 c 0.8,0 1.3,-0.2 1.3,-1 0,-0.8 -0.6,-1 -1.4,-1 h -1.3 v 2 z M 36,35.1 c 0,-0.4 0.2,-0.6 0.5,-0.6 h 2.1 c 1.7,0 2.6,0.6 2.6,2 0,0.8 -0.4,1.4 -1.2,1.6 1,0.3 1.5,0.9 1.5,1.8 0,1.4 -0.9,2 -2.6,2 H 36.5 C 36.1,41.9 36,41.7 36,41.3 Z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 45.6,39.2 v 0 c -1.6,0 -2.2,0.3 -2.2,1 0,0.6 0.4,0.8 1,0.8 0.4,0 0.9,-0.2 1.2,-0.4 z m 0.5,2.8 c -0.4,0 -0.6,-0.2 -0.6,-0.5 V 41.3 C 45,41.8 44.4,42 43.8,42 42.7,42 42,41.4 42,40.4 c 0,-1.5 1.6,-1.8 3.5,-1.9 V 38 c 0,-0.7 -0.5,-1 -1.3,-1 h -1.8 v -0.3 c 0,-0.6 0.7,-0.6 2,-0.6 1.4,0 2.3,0.6 2.3,1.8 v 4 h -0.6 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 48.1,42 v -5.8 h 0.6 c 0.4,0 0.6,0.2 0.6,0.5 v 0.2 c 0.5,-0.5 1.1,-0.7 1.7,-0.7 1.2,0 1.8,0.7 1.8,1.8 v 4 h -1.2 v -4 c 0,-0.6 -0.4,-0.9 -1.1,-0.9 -0.4,0 -0.9,0.2 -1.2,0.4 V 42 Z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 55.3,38.7 2.2,-2.3 c 0.2,-0.2 0.2,-0.3 0.5,-0.3 h 1 c 0,0.1 0,0.2 -0.1,0.3 l -2.4,2.5 2.4,2.8 C 59,41.8 59,41.9 59,42 h -1.1 c -0.3,0 -0.4,-0.1 -0.5,-0.3 l -2,-2.4 V 42 h -1.2 v -7.1 c 0,-0.4 0.1,-0.6 0.5,-0.6 h 0.7 v 4.4 z",
    id: "path12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErste);
export default __webpack_public_path__ + "static/media/erste.af01ae28cd0869bb9a178b5e7ab2006d.svg";
export { ForwardRef as ReactComponent };